import React, { useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';
import GetNewCodeInput from '../GetNewCodeInput';
import { FMessage } from '../../../hoc/IntlComponents';

const PaymentExistingBankCardRU = ({
  data: {
    id,
    number,
    index,
    type,
    isSlave,
    inputFocusHandler,
    inputBlurHandler,
    theme,
    renderWalletsLabel,
    newWalletSMSInputTargetId,
    focusNewInput,
    newWalletSMSInput,
    handleNewWalletChange,
    placeholder,
    newWalletSMSInputError,
    title,
    multiple,
    handleDelete,
    firstname,
    lastname,
    handleEdit,
  },
}) => {
  let initialFirstname = firstname || '';
  let initialLastname = lastname || '';
  const [firstNameInput, setFirstNameInput] = useState(initialFirstname);
  const [lastNameInput, setLastNameInput] = useState(initialLastname);
  return (
    <div>
      <FormGroup>
        {renderWalletsLabel({ id, index })}
        <div className="bank-card-wrapper" theme={theme}>
          <div>
            <Label>
              <FMessage id="payments.purses.card.number" />
            </Label>
            <Input
              id={`purse-${type}-${id}`}
              className="text-uppercase"
              value={number}
              onChange={() => false}
              readOnly={number && number.length && !isSlave}
              disabled={isSlave}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
            />
          </div>
          <div>
            <Label>
              <FMessage id="payments.purses.card.first-name" />
            </Label>
            <Input
              className="text-uppercase"
              value={firstNameInput}
              onChange={e => {
                if (!initialFirstname && !e.target.value.match(/[^a-z]/gi)) {
                  setFirstNameInput(e.target.value.toUpperCase());
                }
              }}
              readOnly={initialFirstname}
              disabled={isSlave}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
              placeholder="IVAN"
            />
          </div>
          <div>
            <Label>
              <FMessage id="payments.purses.card.last-name" />
            </Label>
            <Input
              className="text-uppercase"
              value={lastNameInput}
              onChange={e => {
                if (!initialLastname && !e.target.value.match(/[^a-z]/gi)) {
                  setLastNameInput(e.target.value.toUpperCase());
                }
              }}
              readOnly={initialLastname}
              disabled={isSlave}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
              placeholder="IVANOV"
            />
          </div>
          {multiple ? (
            firstNameInput === initialFirstname && lastNameInput === initialLastname ? (
              <button
                disabled={isSlave}
                onClick={() => handleDelete(id, type)}
                className="btn btn-primary btn-sm bank-card-button"
              >
                <FMessage id="main.delete" />
              </button>
            ) : (
              <button
                disabled={isSlave}
                onClick={() => {
                  handleEdit(id, type, firstNameInput, lastNameInput);
                }}
                className="btn btn-primary btn-sm bank-card-button"
              >
                <FMessage id="main.edit" />
              </button>
            )
          ) : null}
        </div>
      </FormGroup>
      <CSSTransition
        in={newWalletSMSInputTargetId === `purse-${type}-${id}_${index}`}
        timeout={0}
        classNames="new-wallet"
        onEnter={focusNewInput}
      >
        <GetNewCodeInput
          title={title}
          type={type}
          value={newWalletSMSInput}
          handleChange={handleNewWalletChange}
          handleSubmit={() => handleSubmit('newWalletSMSInputError', id)}
          placeholder={placeholder}
          error={newWalletSMSInputError}
          id={`purse-${type}-${id}-sms`}
          className="new-wallet"
          onFocus={inputFocusHandler}
          onBlur={inputBlurHandler}
        />
      </CSSTransition>
    </div>
  );
};

export default PaymentExistingBankCardRU;
